import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Collection } from '@/utils/collectionsGraphQL';

interface DeleteCollectionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  collection: Collection;
  onConfirm: () => Promise<void>;
}

export const DeleteCollectionDialog: React.FC<DeleteCollectionDialogProps> = ({
  open,
  onOpenChange,
  collection,
  onConfirm
}) => {
  const assetCount = collection.assets?.length || 0;

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Collection</AlertDialogTitle>
          <AlertDialogDescription className="space-y-2">
            <div>
              Are you sure you want to delete the collection "{collection.name}"?
            </div>
            {assetCount > 0 && (
              <div className="text-red-600 font-medium">
                This collection contains {assetCount} {assetCount === 1 ? 'asset' : 'assets'} that will also be deleted.
              </div>
            )}
            <div>
              This action cannot be undone.
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction 
            onClick={onConfirm}
            className="bg-red-600 hover:bg-red-700"
          >
            Delete Collection
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};